// first-pphotos[Folder]
import gamchirvaloba from '../../../photos/first-photos/gamchirvaloba.png';
import saia from '../../../photos/first-photos/saia1.jpg';
import safari from '../../../photos/first-photos/safari2.jpg';
import saxli from '../../../photos/first-photos/saxli.jpg';
import tdi from '../../../photos/first-photos/tdi1.jpg';
import gushagi from '../../../photos/first-photos/gushagi1.png';
import egi from '../../../photos/first-photos/egi1.jpg';


// second-photos[Folder]
import green from '../../../photos/second-photos/green1.png';
import wisg from '../../../photos/second-photos/wisg1.png';
import idea from '../../../photos/second-photos/samoqalaqo-idea.png';
import gcrt from '../../../photos/second-photos/gcrt1.jpg';
import isfed from '../../../photos/second-photos/isfed1.jpg';
import ufleba from '../../../photos/second-photos/ufleba1.jpg';

// third-photos[Folder]
import social from '../../../photos/third-photos/social1.jpg';
import saqartvelosDemokratia from '../../../photos/third-photos/sakartvelos-demokratia2.png';
import demokratiisMcveli from '../../../photos/third-photos/demokratiis-mcveli.jpg';
import eecmd from '../../../photos/third-photos/eecmd1.jpg';
import adamianisUflebebi from '../../../photos/third-photos/adamianis-uflebebi.jpg';
import momavali from '../../../photos/third-photos/momavali1.jpg';

//  fourth-photos[Folder]
import idfi from '../../../photos/fourth-photos/idfi.png';
import demokratia from '../../../photos/fourth-photos/demokratiis-instituti.jpg';
import samoqalaqoFondi from '../../../photos/fourth-photos/samoqalaqo-fondi.jpg';

export const ngos = [
  {
    logo: gamchirvaloba,
    alt: "gamchirvaloba",
    links: {
      website: "https://transparency.ge/",
      facebook: "https://www.facebook.com/tigeorgia/",
      instagram: "https://www.instagram.com/transparency_ge/",
      youtube: "https://www.youtube.com/@tigeorgia/",
    }
  },
  {
    logo: saia,
    alt: "Saia",
    links: {
      website: "https://gyla.ge/",
      facebook: "https://www.facebook.com/GYLA.ge",
      instagram: "https://www.instagram.com/gyla.ge/",
      youtube: "https://www.youtube.com/@GYLASAIA/",
    }
  },
  {
    logo: safari,
    alt: "Safari",
    links: {
      website: "https://sapari.ge/",
      facebook: "https://www.facebook.com/unionsapari",
      instagram: "https://www.instagram.com/union.sapari/",
      youtube: "https://www.youtube.com/@sapariunion4415/",
    }
  },
  {
    logo: saxli,
    alt: "Saxli",
    links: {
      website: "https://hrht.ge/",
      facebook: "https://www.facebook.com/humanrightshousetbilisi",
      instagram: "https://www.instagram.com/hrh.tbilisi/",
    }
  },
  {
    logo: tdi,
    alt: "TDI",
    links: {
      website: "https://tdi.ge/",
      facebook: "https://www.facebook.com/tdi.ge/",
    }
  },
  {
    logo: gushagi,
    alt: "Gushagi",
    links: {
      website: "https://courtwatch.ge/",
      facebook: "https://www.facebook.com/WatchCourt",
    }
  },
  {
    logo: egi,
    alt: "EGI",
    links: {
      website: "https://egi.ge/ka/",
      facebook: "https://www.facebook.com/chemiEGI/",
      instagram: "https://www.instagram.com/egi_cso/",
      youtube: "https://www.youtube.com/@europe_georgia",
    }
  },
  {
    logo: green,
    alt: "Green",
    links: {
      website: "https://greenalt.org/",
      facebook: "https://www.facebook.com/greenalt",
      youtube: "https://www.youtube.com/user/greenaltorg",
    }
  },
  {
    logo: wisg,
    alt: "WISG",
    links: {
      website: "https://wisg.org/ka",
      facebook: "https://www.facebook.com/WISG.org/",
      instagram: "https://www.instagram.com/thisiswisg",
    }
  },
  {
    logo: idea,
    alt: "samoqalaqo-idea",
    links: {
      website: "https://civicidea.ge/",
      facebook: "https://www.facebook.com/GeorgianCivicIDEA",
      instagram: "https://www.instagram.com/civic.idea/",
      youtube: "https://www.youtube.com/@civicidea7619",
    }
  },
  {
    logo: gcrt,
    alt: "GCRT",
    links: {
      website: "https://gcrt.ge/",
      facebook: "https://www.facebook.com/gcrt.georgia",
      instagram: "https://www.instagram.com/gcrt.ge",
      youtube: "https://www.youtube.com/@gcrt.georgia",
    }
  },
  {
    logo: isfed,
    alt: "ISFED",
    links: {
      website: "https://www.isfed.ge/",
      facebook: "https://www.facebook.com/isfed.official",
      youtube: "https://www.youtube.com/user/isfed123",
    }
  },
  {
    logo: ufleba,
    alt: "Ufleba",
    links: {
      website: "https://www.rights.ge/ka",
      facebook: "https://www.facebook.com/rights.ge",
      youtube: "https://www.youtube.com/@rightsgeorgia1555/",
    }
  },
  {
    logo: social,
    alt: "Social",
    links: {
      website: "https://socialjustice.org.ge/",
      facebook: "https://www.facebook.com/socialjustice.org.ge",
      youtube: "https://www.youtube.com/user/EMCgeorgia",
    }
  },
  {
    logo: saqartvelosDemokratia,
    alt: "demokratiis-iniciativa",
    links: {
      website: "https://gdi.ge/",
      facebook: "https://www.facebook.com/gdi.ge",
      youtube: "https://www.youtube.com/@infogdi714/",
    }
  },
  {
    logo: demokratiisMcveli,
    alt: "demokratiis-mcveli",
    links: {
      website: "https://www.demdef.org/",
      facebook: "https://www.facebook.com/DemocracyDefendersGeorgia",
    }
  },
  {
    logo: eecmd,
    alt: "eecmd",
    links: {
      website: "https://eecmd.org/ka/",
      facebook: "https://www.facebook.com/EECMD/",
    }
  },
  {
    logo: adamianisUflebebi,
    alt: "adaminis-uflebebi",
    links: {
      website: "https://www.hrc.ge/",
      facebook: "https://www.facebook.com/humanrights.ge",
      youtube: "https://www.youtube.com/@-hrc7843/",
    }
  },
  {
    logo: momavali,
    alt: "Momavali",
    links: {
      website: "https://www.futureacademy.ge/ka",
      facebook: "https://www.facebook.com/geofutureacademy",
      instagram: "https://www.instagram.com/futureacademy.ge/",
      youtube: "https://www.youtube.com/@georgiasfutureacademy2740",
    }
  },
  {
    logo: idfi,
    alt: "idfi",
    links: {
      website: "https://idfi.ge/ge",
      facebook: "https://www.facebook.com/IDFI.official",
      youtube: "https://www.youtube.com/user/IDFIGeorgia",
    }
  },
  {
    logo: demokratia,
    alt: "demokratiis-instituti",
    links: {
      website: "https://www.democracyresearch.org/",
      facebook: "https://www.facebook.com/Democracy.Research.Institute/",
      instagram: "https://www.instagram.com/dri_democracyresearchinstitute/",
      youtube: "https://www.youtube.com/@democracyresearchinstitute7887/",
    }
  },
  {
    logo: samoqalaqoFondi,
    alt: "samoqalaqo-fondi",
    links: {
      website: "https://csf.ge/",
      facebook: "https://www.facebook.com/CivilSocietyFoundation",
      youtube: "https://www.youtube.com/user/OpenSocietyGeorgia1",
    }
  },

  
];